/* ERP · lógica pura das peças calmas (calm.tsx) e das abas da experiência (AreaTabs.tsx). */

/** Abas numa linha só: as primeiras `max` à vista (a atual sempre, no lugar da última) e o resto no "Mais". */
export function splitTabs<T extends { key: string }>(tabs: readonly T[], currentKey: string | null, max = 6): { shown: T[]; rest: T[] } {
    let shown = tabs.slice(0, max)
    const cur = tabs.find(t => t.key === currentKey)
    if (cur && !shown.includes(cur)) shown = [...shown.slice(0, Math.max(0, max - 1)), cur]
    return { shown, rest: tabs.filter(t => !shown.includes(t)) }
}

/** Linha de pulso: no máximo 3 números (o resto é cortado de propósito, para o cabeçalho continuar calmo). */
export const PULSE_MAX = 3
export const clampPulse = <T>(pulse: readonly T[] | undefined): T[] => (pulse ?? []).slice(0, PULSE_MAX)

/** Listas longas: páginas de 16 linhas (pedido do usuário: 18 em 27/10, no lugar do "Mostrar mais"; 16 em 30/10). */
export const PAGE_SIZE = 16

/** Quantas páginas (pelo menos 1). */
export const pageCount = (total: number, size = PAGE_SIZE) => Math.max(1, Math.ceil(Math.max(0, total) / size))

/** A página pedida dentro do intervalo (a lista encolheu com a busca: volta para a última que existe). */
export const clampPage = (page: number, total: number, size = PAGE_SIZE) => Math.min(Math.max(0, Math.trunc(page)), pageCount(total, size) - 1)

/** Faixa da página (início incluído, fim excluído) para `lista.slice(start, end)`. */
export function pageRange(page: number, total: number, size = PAGE_SIZE): { start: number; end: number } {
    const p = clampPage(page, total, size)
    return { start: p * size, end: Math.min(total, (p + 1) * size) }
}

/** Texto da paginação: "19–36 de 134"; null quando cabe numa página só. */
export function pagerLabel(page: number, total: number, size = PAGE_SIZE): string | null {
    if (total <= size) return null
    const { start, end } = pageRange(page, total, size)
    return `${(start + 1).toLocaleString('pt-BR')}–${end.toLocaleString('pt-BR')} de ${total.toLocaleString('pt-BR')}`
}

/** Busca sem acento e sem caixa: "São" casa com "sao". */
export const normalizeSearch = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim()

/** O texto casa com a busca? (busca vazia = tudo; várias palavras = todas precisam aparecer). */
export function matchesSearch(query: string, ...fields: (string | null | undefined)[]): boolean {
    const words = normalizeSearch(query).split(/\s+/).filter(Boolean)
    if (!words.length) return true
    const hay = normalizeSearch(fields.filter(Boolean).join(' '))
    return words.every(w => hay.includes(w))
}
